// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3KoLh","errorLogs":"EditorFooter_errorLogs__cgn0J"};